<template>
  <div class="wachtwoord">
    <v-container fluid class="pt-12 mt-12 pb-12 px-0">
      <v-container class="max-container mx-auto py-12 my-12" :class="[$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pt-12 mt-12']">
        <h3 class=" mb-2 position-relative text-center display-1 mb-6">{{ pageContent.pageTitle }}</h3>
        <v-layout row wrap align-content-center>
          <v-flex xs12 sm8 md6 lg5 xl4 mx-auto>
            <v-card class="elevation-12 mt-4">
              <v-toolbar dark color="primary" class="elevation-0">
                <v-toolbar-title v-html="'Wachtwoord vergeten'"></v-toolbar-title>
              </v-toolbar>
                <form>
                  <v-card-text>
                    <v-text-field
                      prepend-icon="fas fa-user"
                      name="username"
                      label="E-mailadres"
                      type="text"
          					  v-model="email"
          					  :error-messages="errors.email"
                    ></v-text-field>
                    <v-text-field
                      prepend-icon="fas fa-lock"
                      name="password"
                      label="Wachtwoord"
                      id="password"
                      type="password"
          					  v-model="password"
          					  :error-messages="errors.password"
                    >
                    </v-text-field>
                    <v-text-field
                      prepend-icon="fas fa-lock"
                      name="password"
                      label="Wachtwoord(nogmaals)"
                      id="password_again"
                      type="password"
					            v-model="passwordConfirm"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions class="pa-3 white">
					
                    <router-link :to="{ name:'authentication' }">Terug naar inloggen</router-link>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary" to="" class="text-none"
                      v-html="'Wijzig'"
                      @click="handleClick"
                    >
                    </v-btn>
                  </v-card-actions>
                </form>
            </v-card>
          </v-flex>
      		<v-snackbar
      		  v-model="snackbar"
      		  :timeout="timeout"
      		  :color="color"
      		>
      		  {{ text }}
      		  <v-icon>{{ icon }}</v-icon>
      		</v-snackbar>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>

export default {

  name: 'Authentication',
  data() {
    return {
      pageContent: {
        pageTitle: 'P4 Beheer',
      },
      forgotPassword: false,
	  email:'',
	  password:'',
	  passwordConfirm:'',
	  snackbar: false,
      timeout: 3000,
	  errors: {},
	  text: '',
	  icon: '',
	  color: '',
    };
  },
  created()
  {
	if(this.$store.getters.auth != false){
		this.$router.push({name: 'Dashboard'});
	}
  },
  methods: {
	handleClick()
	{
		let data =
		{
			token:this.$route.params.token,
			email: this.email,
			password: this.password,
			password_confirmation: this.passwordConfirm,
		}
		this.$store.dispatch('UserResetPassword', data)
			.then((data) => {
				this.text = data.message;
				this.icon = 'check_circle';
				this.color = 'primary';
				this.snackbar = true;
				this.email = this.password = this.passwordConfirm = '';
			}).catch(error =>{
				this.errors = (error !== undefined) ? error.response.data.errors : {}
			});
	}
  },
  watch:
  {
	email: {handler () { this.errors.email = undefined; }},
	password: {handler () { this.errors.password = undefined; }},
  }
};
</script>
